import { render, staticRenderFns } from "./TasteSettingContainer.vue?vue&type=template&id=a99a0b90&scoped=true&"
import script from "./TasteSettingContainer.vue?vue&type=script&lang=js&"
export * from "./TasteSettingContainer.vue?vue&type=script&lang=js&"
import style0 from "./TasteSettingContainer.vue?vue&type=style&index=0&id=a99a0b90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99a0b90",
  null
  
)

export default component.exports